import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Прячет обвязку сайта в комнате консультации.
 *
 * Футер, кнопка записи и корзина принадлежат сайту клиники, а комната —
 * рабочий экран на время приёма: врачу и пациенту там нужны видео,
 * протокол и файлы, а не навигация по услугам. На телефоне это не
 * придирка к вкусу, а место: футер занимает больше экрана, чем сама
 * консультация, и карточки уезжают под него.
 *
 * Маршрут комнаты один и тот же под двумя префиксами — /cabinet/... у
 * пациента и /admin-panel/... у врача (см. App.tsx), поэтому проверяем
 * общий хвост, а не полный путь.
 */
export const useIsConsultationRoom = (): boolean => {
  const { pathname } = useLocation();
  return pathname.includes('/consultation/');
};

/** Показывает детей везде, кроме комнаты консультации. */
const SiteChrome = ({ children }: { children: ReactNode }) => {
  const inRoom = useIsConsultationRoom();
  return inRoom ? null : <>{children}</>;
};

export default SiteChrome;
